"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALIDATORS = exports.CLASSES = void 0;
var CLASSES = {
  TYPE: {
    TEXT: 'ui-input-text',
    LABEL: 'ui-input-label',
    RANGE: 'ui-input-range'
  },
  STATUS: {
    VALID: 'ui-valid',
    INVALID: 'ui-invalid'
  }
};
exports.CLASSES = CLASSES;
var VALIDATORS = {
  NONE: 'none',
  ALPHA: 'alpha',
  NUMERIC: 'numeric'
};
exports.VALIDATORS = VALIDATORS;